import { message } from "antd";
import { REDIRECT } from "configs/AppConfig";

export const successMessage = (msg, setLoading, redirectPath = null, navigate = null) => {
  const successReturn = setTimeout(() => {
    if (setLoading && typeof setLoading === 'function') {
      setLoading(false);
    }
    message.success(msg);
    if (redirectPath) {
      if (redirectPath === "dashboard") {
        setTimeout(() => window.location.reload(), 1000); // force reload after soft navigate
      } else {
        navigate(REDIRECT + "/" + redirectPath, { replace: true });
      }
    }
  }, 1500);

  return successReturn;
};
export const errorMessage = (msg, setLoading) => {
  const successReturn = setTimeout(() => {
    if (setLoading && typeof setLoading === 'function') {
      setLoading(false);
    }
    message.error(msg);
  }, 1500);

  return successReturn;
};
